import { IRootState } from "../../../../redux/reducers";
import { connect } from "react-redux";
import PaymentRequestRedirect from "./PaymentRequestRedirect";
import { IStateProps, IProps } from "./PaymentRequestRedirect.types";
import * as paymentSelectors from "@rentiohq/shared-frontend/dist/redux/payment/payment.selectors";

const mapStateToProps = (state: IRootState, { id }: IProps): IStateProps => ({
  paymentRequest: paymentSelectors.getPaymentRequest(state, id),
});

export default connect<IStateProps, {}, IProps, IRootState>(mapStateToProps)(
  PaymentRequestRedirect,
);
